import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "absolute bottom-0 inset-x-0 px-container pb-16 lg:pb-32" }
const _hoisted_2 = { class: "font-display text-center text-3xl lg:text-6xl" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Screen Stars of Tomorrow ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" The hottest up-and-coming actors, filmmakers of Spain ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Esta mañana se ha presentado en Palma (Mallorca) la undécima edición de Atlàntida Mallorca Film Fest, el festival de cine, música y conferencias de Filmin que, por sexto año consecutivo, tendrá una naturaleza híbrida: del 26 de julio al 1 de agosto el certamen se celebrará en Palma, mientras que del 26 de julio al 26 de agosto una versión ampliada de su programación de películas y documentales estará disponible online en Filmin. ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Hero = _resolveComponent("Hero")
  const _component_PageTitle = _resolveComponent("PageTitle")
  const _component_PageContent = _resolveComponent("PageContent")
  const _component_PageContainer = _resolveComponent("PageContainer")
  const _component_FollowFestival = _resolveComponent("FollowFestival")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Hero, null, {
      default: _withCtx(() => [
        _createVNode("div", _hoisted_1, [
          _createVNode("h1", _hoisted_2, [
            _createVNode("img", {
              src: `${_ctx.baseURL}img/screen/screen.png`,
              srcset: `
            ${_ctx.baseURL}img/screen/screen.png     400w,
            ${_ctx.baseURL}img/screen/screen@2x.png  800w,
            ${_ctx.baseURL}img/screen/screen@3x.png 1200w
          `,
              alt: "Screen International",
              class: "w-96 max-w-full px-8 lg:px-0 mb-8 mx-auto shadow-sm"
            }, null, 8, ["src", "srcset"]),
            _hoisted_3
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_PageContainer, null, {
      default: _withCtx(() => [
        _createVNode(_component_PageTitle, null, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }),
        _createVNode(_component_PageContent, null, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_FollowFestival)
  ], 64))
}